import React from "react";
import {
  // HiXCircle,
  // HiOutlineSun,
  // HiOutlineTrash,
  // HiOutlineArrowsExpand,
  // HiLightBulb,
  AiOutlineUngroup,
  // HiOutlineX,
} from "react-icons/ai";
import { useTranslation } from "react-i18next";

export default function UnGroupButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("UnGroup Selection")}
      >
        <span className="icon is-small has-text-light">
          <AiOutlineUngroup className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
